// extracted by mini-css-extract-plugin
export var baseButton = "_v9-0";
export var controlsArrowKeys = "_v9-1";
export var controlsResetButton = "_v9-2";
export var lightGameButton = "_v9-4 _v9-0";
export var playAgainButton = "_v9-5 _v9-0";
export var startGameButton = "_v9-3 _v9-0";